const menuConfig = [
    // ── Rastreamento ──────────────────────────────────────────────────────────
    {
        menuId: 2000,
        level: 1,
        name: "Rastreamento",
        route: "Rastreamento",
        icon: "FcShipped",
        active: true,
    },
    {
        menuId: 2010,
        level: 2,
        name: "Minha Frota",
        route: "fleet",
        icon: "MdOutlineLocalShipping",
        active: true,
    },
    {
        menuId: 2040,
        level: 2,
        name: "Visualizar Mapa",
        route: "mapfilters",
        icon: "FaMapMarkedAlt",
        active: true,
    },
    {
        menuId: 2050,
        level: 2,
        name: "Roteirização",
        route: "routing",
        icon: "LuRoute",
        active: true,
    },
    {
        menuId: 2060,
        level: 2,
        name: "Mais Próximo",
        route: "vehicles/nearby",
        icon: "RiRulerLine",
        active: true,
    },
    {
        menuId: 2100,
        level: 2,
        name: "Apelido",
        route: "vehicles/nickname",
        icon: "IoPricetagOutline",
        active: true,
    },

    // ── Grupos ────────────────────────────────────────────────────────────────
    {
        menuId: 2109,
        level: 1,
        name: "Grupos",
        route: "groups",
        icon: "LuGroup",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 2110,
        level: 2,
        name: "Grupos",
        route: "groups",
        icon: "LuGroup",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 2113,
        level: 2,
        name: "Veículos",
        route: "linked-vehicles",
        icon: "FcShipped",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 2114,
        level: 2,
        name: "Usuários",
        route: "group-users",
        icon: "FcShipped",
        leveName: "GESTOR REGIONAL",
        active: true,
    },

    // ── Controle ──────────────────────────────────────────────────────────────
    {
        menuId: 4000,
        level: 1,
        name: "Controle",
        route: null,
        icon: "GoShieldCheck",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 4010,
        level: 2,
        name: "Ponto de Visita",
        route: "visitpoint",
        icon: "GiPositionMarker",
        active: true,
    },
    {
        menuId: 4030,
        level: 2,
        name: "Cerca Eletrônica",
        route: "electric-fence",
        icon: "LuFence",
        active: true,
    },
    {
        menuId: 4035,
        level: 2,
        name: "Cerca Poligonal",
        route: "polygon-fences",
        icon: "FcShipped",
        active: true,
    },
    {
        menuId: 4040,
        level: 2,
        name: "Área de Risco",
        route: "risk-area",
        icon: "MdOutlineDangerous",
        active: true,
    },

    // ── Relatórios ────────────────────────────────────────────────────────────
    {
        menuId: 3000,
        level: 1,
        name: "Relatórios",
        route: null,
        icon: "LuPrinter",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 3010,
        level: 2,
        name: "Jornada de Trabalho",
        route: "journeywork",
        icon: "FcClock",
        active: true,
    },
    {
        menuId: 3020,
        level: 2,
        name: "Posicionamento",
        route: "vehiclepositions",
        icon: "LuRoute",
        active: true,
    },
    {
        menuId: 3030,
        level: 2,
        name: "Distância Percorrida",
        route: "travelleddistance",
        icon: "FcRadarPlot",
        active: true,
    },
    {
        menuId: 3040,
        level: 2,
        name: "Controle de Uso",
        route: "vehicleactivities",
        icon: "FcInTransit",
        active: true,
    },
    {
        menuId: 3060,
        level: 2,
        name: "Veículos em Visitas",
        route: "visitsvehicle",
        icon: "LiaSearchLocationSolid",
        active: true,
    },
    {
        menuId: 3070,
        level: 2,
        name: "Visitas por Veículos",
        route: "vehiclevisits",
        icon: "IoIosTimer",
        active: true,
    },
    {
        menuId: 3080,
        level: 2,
        name: "Atividade Veicular",
        route: "vehicle-activity-report",
        icon: "IoMdSpeedometer",
        active: true,
    },
    {
        menuId: 3090,
        level: 2,
        name: "Resumo de Veiculos",
        route: "summary-vehicles",
        icon: "FcInTransit",
        active: true,
    },
    {
        menuId: 3100,
        level: 2,
        name: "Controle de Velocidade",
        route: "speedcontrol",
        icon: "FcSportsMode",
        active: true,
    },

    // ── Cadastros ─────────────────────────────────────────────────────────────
    {
        menuId: 5000,
        level: 1,
        name: "Cadastros",
        route: null,
        icon: "AiFillCar",
        leveName: "GESTOR REGIONAL",
        edit: "S",
        active: true,
    },
    {
        menuId: 5010,
        level: 2,
        name: "Clientes",
        route: "customers",
        icon: "AiFillCar",
        active: true,
    },
    {
        menuId: 5011,
        level: 2,
        name: "Novos Clientes",
        route: "customers",
        icon: "HiOutlineBuildingOffice2",
        active: false,
    },
    {
        menuId: 5050,
        level: 2,
        name: "Cadastro de Motorista",
        route: "driver",
        icon: "HiOutlineUsers",
        active: true,
    },
     {
        menuId: 5055,
        level: 2,
        name: "Lançamento de Combustível",
        route: "fuels",
        icon: "MdLocalGasStation",
        active: true,
    },

    // ── Atendimento ───────────────────────────────────────────────────────────
    {
        menuId: 6000,
        level: 1,
        name: "Atendimento",
        route: null,
        icon: "RiCustomerService2Line",
        active: true,
    },
    {
        menuId: 6900,
        level: 2,
        name: "Protocolos",
        route: "protocols",
        icon: "SiWheniwork",
        active: true,
    },
    {
        menuId: 6700,
        level: 2,
        name: "Resumo de Protocolos",
        route: "protocol-summary",
        icon: "MdSummarize",
        active: true,
    },
    {
        menuId: 6500,
        level: 2,
        name: "Alertas",
        route: "alerts",
        icon: "MdWarningAmber",
        active: true,
    },

    // ── Manutenção ────────────────────────────────────────────────────────────
    {
        menuId: 7000,
        level: 1,
        name: "Manutenção",
        route: null,
        icon: "GoTools",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 7010,
        level: 2,
        name: "Itens",
        route: "maintenances/items",
        icon: "GoListOrdered",
        active: true,
    },
    {
        menuId: 7020,
        level: 2,
        name: "Agendamento",
        route: "maintenances/scheduling",
        icon: "TfiAgenda",
        active: true,
    },
    {
        menuId: 7030,
        level: 2,
        name: "Acompanhamento",
        route: "maintenances/shipping",
        icon: "HiOutlineDocumentMagnifyingGlass",
        active: true,
    },
    {
        menuId: 7040,
        level: 2,
        name: "Manutenções Pendentes",
        route: "maintenances/pendings",
        icon: "GrVmMaintenance",
        active: true,
    },
    {
        menuId: 7050,
        level: 2,
        name: "Manutenções Realizadas",
        route: "maintenances/completed",
        icon: "GrHostMaintenance",
        active: true,
    },
    {
        menuId: 7060,
        level: 2,
        name: "Acompanhamento",
        route: "maintenances/shipping",
        icon: "HiOutlineDocumentMagnifyingGlass",
        active: false,
    },
    {
        menuId: 7500,
        level: 2,
        name: "Registro do Odômetro",
        route: "maintenances/register",
        icon: "GrNotes",
        active: true,
    },   

    // ── Equipamentos ──────────────────────────────────────────────────────────
    {
        menuId: 11000,
        level: 1,
        name: "Equipamentos",
        route: null,
        icon: "FcSmartphoneTablet",
        active: true,
    },
    {
        menuId: 11030,
        level: 2,
        name: "Equipamentos",
        route: "equipments",
        icon: "FcSmartphoneTablet",
        active: true,
    },
    {
        menuId: 11060,
        level: 2,
        name: "Chips",
        route: "chips",
        icon: "FcSimCardChip",
        active: true,
    },

    // ── Cadastro de Veículo (admin) ────────────────────────────────────────────
    {
        menuId: 12000,
        level: 1,
        name: "Cadastro de Veículo",
        route: "vehicle",
        icon: "AiFillCar",
        leveName: "ADMINISTRADOR",
        edit: "S",
        active: true,
    },
    {
        menuId: 12010,
        level: 2,
        name: "Veículos",
        route: "vehicle",
        icon: "AiFillCar",
        leveName: "ADMINISTRADOR",
        edit: "N",
        active: true,
    },
    {
        menuId: 12020,
        level: 2,
        name: "Montadoras",
        route: "manufacturer",
        icon: "FaFileSignature",
        leveName: "ADMINISTRADOR",
        edit: "N",
        active: true,
    },
    {
        menuId: 12030,
        level: 2,
        name: "Modelos",
        route: "models",
        icon: "FaFileSignature",
        leveName: "ADMINISTRADOR",
        edit: "S",
        active: true,
    },
    {
        menuId: 12040,
        level: 2,
        name: "Cores",
        route: "colors",
        icon: "FaFileSignature",
        leveName: "ADMINISTRADOR",
        edit: "S",
        active: true,
    },
    {
        menuId: 12050,
        level: 2,
        name: "Categorias",
        route: "categories",
        icon: "FaFileSignature",
        leveName: "ADMINISTRADOR",
        edit: "S",
        active: true,
    },

    // ── Fretamento ────────────────────────────────────────────────────────────
    {
        menuId: 19000,
        level: 1,
        name: "Fretamento",
        route: null,
        icon: "MdDirectionsBus",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 19010,
        level: 2,
        name: "Clientes",
        route: "chartering/clients",
        icon: "HiOutlineBuildingOffice2",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 19020,
        level: 2,
        name: "Linhas",
        route: "chartering/paths",
        icon: "LuRoute",
        leveName: "GESTOR REGIONAL",
        active: true,
    },

    // ── Sistema ───────────────────────────────────────────────────────────────
    {
        menuId: 18000,
        level: 1,
        name: "Sistema",
        route: null,
        icon: "SiDwavesystems",
        leveName: "GESTOR REGIONAL",
        active: true,
    },
    {
        menuId: 18020,
        level: 2,
        name: "Log",
        route: "systemlogs",
        icon: "IoLogoBuffer",
        active: true,
    },
    {
        menuId: 18030,
        level: 2,
        name: "Perfil de Acesso",
        route: "access-profile",
        icon: "MdOutlineAdminPanelSettings",
        active: true,
    },
];

export default menuConfig;
